module.exports = __webpack_public_path__ + "static/img/Luke_Parker_mobile.2e3ac99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Luke_Parker_mobile.jpg
// module id = /f6R
// module chunks = 0